const IMAGE_URL = 'https://s3.us-east-2.amazonaws.com/file.wincloudaitech/icons'


export const APP_QR_CODE = `${IMAGE_URL}/logo.jpg`;

